import {Record} from 'immutable';

import {Address, getCountryAndState} from './model-address';

class Doctor extends Record<{
    name?: string;
    phone?: string;
    address?: Address;
    country?: string;
    state?: string;
}>({
    name: '',
    phone: '',
    address: new Address(),
    country: '',
    state: '',
}) {}

function fromAPI(data) {
    return new Doctor({
        name: data.name,
        phone: data.phone,
        address: new Address({
            city: data.addressCity,
            zip: data.addressZip,
            street: data.addressStreet,
            country: data.addressCountry,
            state: data.addressState,
            countryInput: '',
        }),
    });
}

const toAPI = (doctor: Doctor) => {
    const {country, state} = getCountryAndState(doctor.address);

    const payloadToSend = {
        doctorName: doctor.name,
        doctorPhone: doctor.phone,
        doctorAddressCity: doctor?.address?.city,
        doctorAddressZip: doctor?.address?.zip,
        doctorAddressStreet: doctor?.address?.street,
        doctorAddressCountry: country,
        doctorAddressState: state,
    };

    return payloadToSend;
};

export default {
    record: Doctor,
    default: new Doctor(),
    fromAPI,
    toAPI,
};
